<template>
  <div class="mod-overlay">
    <div class="mod-modal emp-modal">

      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i class="bi bi-building"></i>
          Seleccionar Empresa
        </h3>
      </div>

      <!-- Body -->
      <div class="mod-modal-body">
        <p class="emp-subtitle">Debe seleccionar una empresa para continuar:</p>

        <div v-if="empresasActivas.length === 0" class="emp-empty">
          <i class="bi bi-exclamation-triangle"></i>
          <span>No hay empresas disponibles</span>
        </div>

        <div class="emp-list">
          <div
            v-for="empresa in empresasActivas"
            :key="empresa.EmpresaId"
            class="emp-item"
            :class="{ 'emp-item-selected': selectedEmpresa?.EmpresaId === empresa.EmpresaId }"
            @click="selectEmpresa(empresa)"
          >
            <div class="emp-item-inner">
              <div class="emp-item-info">
                <span class="emp-item-nombre">{{ empresa.Nombre }}</span>
                <span class="emp-item-codigo">Código: {{ empresa.Codigo || empresa.EmpresaId }}</span>
              </div>
              <div v-if="selectedEmpresa?.EmpresaId === empresa.EmpresaId" class="emp-item-check">
                <i class="bi bi-check-circle-fill"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="mod-modal-footer">
        <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
          <i class="bi bi-x"></i>
          Cancelar
        </button>
        <button
          type="button"
          class="mod-btn mod-btn-save"
          :disabled="!selectedEmpresa || loading"
          @click="confirmarSeleccion"
        >
          <span v-if="loading" class="mod-spinner-sm"></span>
          <template v-else>
            <i class="bi bi-check"></i>
            Continuar
          </template>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import authService from '@/shared/services/auth';

export default {
  name: 'EmpresaSelector',
  emits: ['empresa-selected', 'close'],
  data() {
    return {
      empresas: [],
      selectedEmpresa: null,
      loading: false
    };
  },
  computed: {
    empresasActivas() {
      return this.empresas.filter(e => e.EsActivo === true || e.EsActivo == null);
    }
  },
  created() {
    this.loadEmpresas();
  },
  methods: {
    loadEmpresas() {
      const userData = authService.getUserData();
      if (userData?._UsuarioMo?._EmpresaList) {
        this.empresas = userData._UsuarioMo._EmpresaList;
        // Si solo hay una empresa, preseleccionarla
        if (this.empresas.length === 1) {
          this.selectedEmpresa = this.empresas[0];
        }
      } else {
        this.empresas = [];
      }
    },
    selectEmpresa(empresa) {
      this.selectedEmpresa = empresa;
    },
    async confirmarSeleccion() {
      if (!this.selectedEmpresa || this.loading) return;
      this.loading = true;
      try {
        await authService.setSelectedEmpresa(this.selectedEmpresa);
        this.$emit('empresa-selected', this.selectedEmpresa);
      } catch (e) {
        console.error('Error al seleccionar empresa:', e);
        this.$emit('empresa-selected', this.selectedEmpresa);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";

.emp-modal {
  max-width: 480px;
}

.emp-subtitle {
  font-size: 0.875rem;
  color: #718096;
  margin: 0 0 1rem;
}

.emp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2rem 1rem;
  color: #a0aec0;
  font-size: 0.875rem;
}

.emp-empty i {
  font-size: 1.75rem;
  color: #f6ad55;
}

.emp-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.emp-item {
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.18s;
  background: #ffffff;
}

.emp-item:hover {
  border-color: #1272c4;
  background: #f7faff;
}

.emp-item-selected {
  border-color: #1a7e3c;
  background: #f0fff4;
}

.emp-item-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  background: #f7fafc;
}

.emp-item-selected .emp-item-inner {
  background: #f0fff4;
}

.emp-item-info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.emp-item-nombre {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1a202c;
}

.emp-item-codigo {
  font-size: 0.8rem;
  color: #718096;
}

.emp-item-check {
  font-size: 1.35rem;
  color: #1a7e3c;
  line-height: 1;
}
</style>
